import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Bezpieczny podgląd pliku chronionego: pobiera przez uwierzytelniony nagłówek (blob),
// BEZ umieszczania długotrwałego tokenu w adresie URL.
export default function ProtectedImg({ fileId, alt = "", className = "" }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let url = "";
    let cancelled = false;
    if (!fileId) return undefined;
    api.get(`/files/${fileId}`, { responseType: "blob" })
      .then((r) => { if (!cancelled) { url = URL.createObjectURL(r.data); setSrc(url); } })
      .catch(() => {});
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [fileId]);
  if (!src) return <div className={`bg-secondary ${className}`} />;
  return <img src={src} alt={alt} className={className} />;
}
